import React, { useState } from 'react';
import classNames from './style.module.scss';
import placeholder from '../../../assets/images/placeholder.png';

interface Props {
	src: string;
	className?: string;
	alt: string;
	style?: React.CSSProperties;
}

const Image: React.FC<Props> = ({ alt, className, src, style }) => {
	const [loaded, setLoaded] = useState(false);

	return (
		<div className={classNames.header}>
			{!loaded && <div className={classNames.loading}>Loading...</div>}

			<img
				src={src}
				alt={alt}
				className={className}
				style={style}
				onLoad={() => setLoaded(true)}
				onError={(event) => (event.currentTarget.src = placeholder)}
			/>
		</div>
	);
};

export default Image;
